var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "app-main",
      style: { marginLeft: false ? "94px" : "200px" },
    },
    [
      _c("HocHistoryNav"),
      _vm.noCache ? _c("router-view", { key: _vm.key }) : _vm._e(),
      _c(
        "keep-alive",
        { attrs: { max: "15" } },
        [!_vm.noCache ? _c("router-view", { key: _vm.key }) : _vm._e()],
        1
      ),
      _c("BackToTop"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }